<template>
    <div class="Login">
        <div class="Login--main">
            <img src="../../assets/img/logo.svg">

            <div class="Login--main-form">
                <component :is="loginFormView"/>
            </div>

            <div class="Login--main-footer">© Popsicle <sup>TM</sup></div>
        </div>

        <template v-if="schoolInfo">
            <div class="Login--image"
                 :style="{ 'background-image': schoolInfo.backgroundImage && `url(${schoolInfo.backgroundImage})`}"
            >
                <div class="Login--image-gradient"/>

                <div class="Login--image-content">
                    <rounded-icon class="kids-hope"
                                  :size="80"
                                  :img-src="schoolInfo.logo ? schoolInfo.logo : require('../../assets/img/Default_School_Logo.png')"
                    />

                    <h1 class="Login--image-content-goal">
                        {{schoolInfo.schoolName}}
                    </h1>

                    <h1 v-if="schoolInfo.tagLine"
                        class="Login--image-content-goal mt-3"
                    >
                        {{schoolInfo.tagLine}}
                    </h1>

                    <div class="Login--image-content-address">
                        <p class="m-0">{{schoolInfo.street}}</p>
                        <p class="m-0">{{schoolInfo.city}}, {{schoolInfo.state}} {{schoolInfo.zip}}</p>
                        <p class="m-0">{{schoolInfo.country}}</p>
                    </div>
                </div>
            </div>
        </template>

    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { NotificationsTypes } from '@/constants/notificationsTypes';

    export default {
        name: 'Login',

        components: {
            RoundedIcon: () => import('@/components/controls/RoundedIcon'),
            SignInForm: () => import('@/components/no-auth/SignInForm'),
            SignUpForm: () => import('@/components/no-auth/SignUpForm'),
            ForgotPasswordForm: () => import('@/components/no-auth/ForgotPasswordForm')
        },

        computed: {
            ...mapGetters(['loginFormView', 'schoolInfo'])
        },

        methods: {
            ...mapActions(['verificationChangeEmail', 'getSchoolInfo', 'changeLoginForm']),
        },

        async created() {
            this.getSchoolInfo();

            this.$router.currentRoute.query.resetToken && this.changeLoginForm('forgot-password-form');

            const verificationToken = this.$router.currentRoute.query.emailChangeToken;

            if (!verificationToken) return;

            try {
                await this.verificationChangeEmail({ verificationToken });
            } catch (e) {
                this.createNotification({
                    message: e.data,
                    type: NotificationsTypes.ERROR
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/styles/variables/colors';

    .Login {
        position: relative;
        width: 100%;
        min-height: 100vh;
        display: flex;

        &--main {
            width: 40%;
            min-width: 375px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            padding: 3% 5%;
            @media screen and (max-width: 700px) {
                width: 80%;
                margin: 0 auto;
            }
            @media screen and (max-width: 425px) {
                width: 100%;
                padding: 3%;
            }

            &-form {
                width: 100%;
                @media screen and (max-width: 425px) {
                    width: 94%;
                }
            }

            &-footer {
                width: 100%;
                text-align: center;
                font-weight: 400;
                font-size: 13px;
                color: $Copyright;
            }
        }

        &--image {
            position: fixed;
            left: 40%;
            width: 60%;
            height: 100vh;
            background-size: cover;
            background-image: url('../../assets/img/rectangle-16.jpg');
            @media screen and (max-width: 700px) {
                display: none;
            }

            &-gradient {
                width: 100%;
                height: 100%;
                opacity: 0.35;
                background-image: linear-gradient(47deg, #3023ae, #b12269 71%, #e5214e), linear-gradient(rgba(0, 0, 0, 0.29), rgba(0, 0, 0, 0.29));
            }

            &-content {
                z-index: 2;
                position: absolute;
                top: 245px;
                left: 90px;
                @media screen and (max-width: 900px) {
                    top: 20%;
                    left: 50px;
                }

                &-goal {
                    margin-top: 33px;
                    font-weight: 700;
                    font-size: 36px;
                    word-break: break-word;
                    color: $White;
                    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {  //for IE
                        word-break: break-all;
                    }
                }

                &-address {
                    width: 250px;
                    margin-top: 40px;
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 1.33;
                    word-break: break-word;
                    color: $White;
                    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {  //for IE
                        word-break: break-all;
                    }
                }

                img.kids-hope {
                    width: 80px;
                    height: 80px;
                    border-radius: 40px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/no-auth/Login.vue